(function ($, window) {

    $(function() {
        $('.contact-map__form').each(function(idx, form) { submitTo(form, formhandle) });
        $('.school-signup__form').each(function(idx, form) { submitTo(form, formhandle) });
    });

    function formhandle(form) {
        // Create submit handler for contact form
        var f = $(form),
            $btn = $('button', f),
            isBtn = $btn.length > 0,
            orig = 'Send';

        // remove previous error messages
        $('.error', f).remove();

        if(isBtn) {
            orig = $btn.html();
            $btn.html(Contenda.t('Vent'));
        } else {
            $btn = $('input[type=submit]', f);
            orig = $btn.val();
            $btn.val(Contenda.t('Vent'));
        }

        $btn.attr('disabled','disabled');

        $.post(f.attr('action'),
            f.serialize(),
            function(data) { // success
                // f.closest('.widgetElement').addClass('contenda-formSuccess');
                var $success = $('<div class="success">'+Contenda.t('Tak for din henvendelse')+'</div>');
                $success.insertBefore(f);

                // slide into view
                $('html, body').animate({
                    'scrollTop': $success.offset().top - 50
                });

                // slide up form
                f.animate({
                    opacity: 0,
                    height: 0
                }, function() {
                    f.remove();
                });
            }, 'json')
            .fail(function(data) { // error
                f.prepend('<li class="error">Der skete en fejl: '+Contenda.t(data.responseText)+'</li>');
                $btn.removeAttr('disabled');

                isBtn ? $btn.html(orig) : $btn.val(orig);
            });
    }

})(jQuery, window);